import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../../assets/BLH_Icon.svg";

const Footer = () => {
  return (
    <footer className="bg-slate-900 py-[60px] px-[5%] pb-[32px] text-slate-200/60 text-left">
      <div className="footer-top flex flex-wrap gap-10 md:justify-between md:items-start pb-[40px] mb-[32px] border-b border-white/10">
        <div className="footer-brand">
          <Link to="/" className="nav-logo inline-flex items-center gap-[10px] mb-4 no-underline">
            <div className="w-9 h-9 bg-white rounded-lg flex items-center justify-center">
               <img src={logo} alt="Business Lending Hub" className="w-full h-full -mt-3 object-cover rounded" /> 
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white" />
            </div>
            <span className="text-lg font-bold text-white">The Business Lending Hub</span>
          </Link>
          <p className="text-[0.85rem] max-w-[260px] leading-[1.65] mt-[10px] text-slate-300">
            Empowering loan brokers and lenders with the tools to manage every deal — from first contact to funded.
          </p>
        </div>
        
        <div className="footer-links">
          <h4 className="text-[0.82rem] font-bold uppercase tracking-[0.07em] mb-[14px] text-white">
            Platform
          </h4>
          <ul className="space-y-2 m-0 p-0 list-none">
            <li><button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">Features</button></li>
            <li><button onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">How It Works</button></li>
            <li><button onClick={() => document.getElementById('for-you')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">For Brokers</button></li>
            <li><button onClick={() => document.getElementById('for-you')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">For Lenders</button></li>
          </ul>
        </div>
        
        <div className="footer-links">
          <h4 className="text-[0.82rem] font-bold uppercase tracking-[0.07em] mb-[14px] text-white">
            Company
          </h4>
          <ul className="space-y-2 m-0 p-0 list-none">
            <li><button onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">About Us</button></li>
            <li><button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">Contact</button></li>

          </ul>
        </div>
        
        <div className="footer-links">
          <h4 className="text-[0.82rem] font-bold uppercase tracking-[0.07em] mb-[14px] text-white">
            Get Started
          </h4>
          <ul className="space-y-2 m-0 p-0 list-none">
            <li><button onClick={() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">Request a Demo</button></li>
            <li><button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-slate-400/90 hover:text-white transition-colors no-underline bg-transparent border-none p-0 cursor-pointer">Partner with Us</button></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom flex flex-wrap gap-3 justify-between items-center text-[0.8rem] pt-8">
        <span>© 2026 The Business Lending Hub. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;

